{
  "serie": {
    "display": "Diagramm anzeigen",
    "hide": "Diagramm ausblenden",
    "remove": "Warenkorb entfernen",
    "displaySettings": "Diagrammeinstellungen anzeigen",
    "selectColor": "Klicken Sie, um eine Farbe auszuwählen",
    "color": "Farbe",
    "type": "Typ",
    "types": {
      "line": "Linie",
      "bar": "Balken"
    }
  }
}
